enum WaterEfficiencyClassModalEnum {
	waterLabelCard = 'waterLabelCard'
}
export default WaterEfficiencyClassModalEnum;
